(() => {
  'use strict';
  document.querySelectorAll('[data-amc-quote-product]').forEach(root => {
    if (root.dataset.releaseQuantityReady) return;
    root.dataset.releaseQuantityReady = 'true';
    const quantity = root.querySelector('[data-uq-qty]');
    root.querySelectorAll('[data-uq-step]').forEach(button => {
      button.addEventListener('click', () => {
        const value = Math.floor(Number(quantity.value) || 1);
        quantity.value = String(Math.max(1, Math.min(999, value + Number(button.dataset.uqStep))));
        quantity.dispatchEvent(new Event('input', {bubbles: true}));
        quantity.dispatchEvent(new Event('change', {bubbles: true}));
      });
    });
    root.querySelectorAll('[data-uq-request],[data-uspe-po-link]').forEach(link => {
      link.addEventListener('click', () => {
        const selection = root.querySelector('[data-uq-variant]');
        const option = selection?.selectedOptions[0];
        const qty = Math.max(1, Math.min(999, Math.floor(Number(quantity.value) || 1)));
        const item = {
          productId: root.dataset.productid,
          title: root.dataset.title || root.querySelector('h1')?.textContent.trim() || '',
          url: root.dataset.url || location.pathname,
          variantId: String(selection?.value || ''),
          model: option?.dataset.model || '',
          quantity: qty,
          requirements: []
        };
        const key = 'USPEModelConfigurationV1';
        try {
          // The structured options controller preserves distinct wording/notes
          // as separate request lines. Do not collapse those lines by variant.
          if (!root.querySelector('[data-uspe-model-options]')) {
          const parsed = JSON.parse(localStorage.getItem(key) || '[]');
          const saved = Array.isArray(parsed) ? parsed : [];
          const previous = saved.find(row => row?.productId === item.productId && row?.variantId === item.variantId);
          if (Array.isArray(previous?.requirements)) item.requirements = previous.requirements;
          localStorage.setItem(key, JSON.stringify(
            [...saved.filter(row => !(row?.productId === item.productId && row?.variantId === item.variantId)), item].slice(-50)));
          }
        } catch (_) {
          // URL fields preserve the base selection when browser storage is unavailable.
        }
        if (link.hasAttribute('data-uspe-po-link')) {
          const url = new URL(link.href, location.origin);
          url.searchParams.set('model', item.model);
          url.searchParams.set('variant', item.variantId);
          url.searchParams.set('quantity', String(qty));
          url.searchParams.set('product_url', item.url);
          link.href = url.toString();
        }
      }, {capture: true});
    });
  });
})();
